module.exports = __webpack_public_path__ + "ggmpa/img/logo.385e802.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = iQH9
// module chunks = 1 2 3 4 5 6